export enum DtwinFormOperationListColumns {
  VERSION = "version",
  TRIGGER = "trigger",
  CREATED_AT = "createdAt",
  LAUNCHED_AT = "launchedAt",
  MODIFIED_AT = "modifiedAt",
  STATUS = "status",
  ACTION = "action",
}
